export * from './interfaces/client-autocomplete-item.interface';

export * from './client-autocomplete.component';
